import { createAsyncThunk } from '@reduxjs/toolkit';
import _get from 'hs-lodash/get';
import { appActions } from 'in-meeting-experience-ui-components/contexts/app/context';
import { CALL_UNIQUE_EXTERNAL_ID_PROPERTY } from '../../constants/callObject';
import { DEFAULT_TOPIC } from '../../constants/google-meet';
import { meetingIdSelector, meetingStartTimeSelector, meetingUUIDSelector, meetingUriSelector } from '../google/selectors';
import { googleActions } from '../google/slice';
export const fetchCallObject = createAsyncThunk('callObject/fetchCallObject', (_args, thunkAPI) => {
  const meetingID = meetingIdSelector(thunkAPI.getState());
  const meetingUUID = meetingUUIDSelector(thunkAPI.getState());
  const startTime = meetingStartTimeSelector(thunkAPI.getState());
  const joinUrl = meetingUriSelector(thunkAPI.getState());
  return thunkAPI.extra.callObjectApi.fetchCallObjectV2({
    meetingUid: meetingUUID || '',
    meetingId: meetingID || '',
    title: DEFAULT_TOPIC || '',
    startTime: startTime || null,
    joinUrl: joinUrl || ''
  }).catch(error => thunkAPI.rejectWithValue(error));
});
export const getCallObjectById = createAsyncThunk('callObject/getCallObjectById', (id, thunkAPI) => thunkAPI.extra.callObjectApi.fetchCallObjectById({
  id
}).then(callObject => {
  const meetingID = _get(callObject.properties.hs_call_meeting_id, 'value', '');
  const meetingUUID = _get(callObject.properties[CALL_UNIQUE_EXTERNAL_ID_PROPERTY], 'value', '');
  thunkAPI.dispatch(googleActions.receiveMeetingId(meetingID));
  if (meetingID && meetingUUID) {
    appActions.setIsPastMeeting(true);
  }
  return callObject;
}).catch(error => thunkAPI.rejectWithValue(error)));